import anime from "animejs";

export default function initStatisticAnimation(el) {
  const targets = {
    target: "0",
  };

  // There's a bug where whole numbers including 000 get rounded to just 0
  // Example: 97,000 becomes 97,0
  // Example: 97,000,000 becomes 97,0,0
  // Example: 97,000,456 becomes 97,0,456
  // Doing a check here to be used in the complete function below
  const hasZeroes = el.dataset.value.includes("000");

  const hasDecimal = el.dataset.value.includes(".");
  const hasComma = el.dataset.value.includes(",");

  let round;
  if (hasDecimal) {
    round = 100;
  } else if (!hasDecimal && !hasComma) {
    round = 1;
  } else {
    round = true;
  }

  anime({
    targets: targets,
    target: el.dataset.value,
    round: round,
    easing: "linear",
    update: function () {
      el.querySelector(".js-value").innerHTML = targets.target;
    },
    complete: function () {
      if (hasZeroes) {
        // For some reason, this correctly displays a whole number including 000
        el.querySelector(".js-value").innerHTML = el.dataset.value.concat("");
      }
    },
  });
}
